import React from 'react';
import '../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';
import Footer from '../includes/Footer';
import img1 from 'Images/about_1@2x.png';
import img2 from 'Images/about_2@2x.png';

class About extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <React.Fragment>
        <div
          style={{
            maxWidth: '1024px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Grid
            spacing={0}
            container
            //alignItems={'center'}
            justify={'center'}
            spacing={0}
            className="template-about"
          >
            <Grid item md={12} sm={8} xs={9} className="u-mrg-bot-50">
              <h1 className="template-terms-main-title c-blue-dark ">About</h1>
              <p className="t-secondary-16 lh-24">
                <b>Luminaire Broker</b> is a tool to facilitate communication
                between specifiers and lighting equipment suppliers. It creates
                the means for specifiers to be exposed to a greater range of
                products, and suppliers to closely match their products to
                specific requirements. Luminaire Broker improves the process for
                selecting lighting products for a project and streamlines the
                preparation of lighting specifications.
              </p>
              <p className="t-secondary-16 lh-24">
                Luminaire Broker has been developed to support Lighting
                Designers and Electrical Engineers in developing and specifying
                the lighting schemes for their projects, allowing them to match
                the optimal lighting product to each application.
              </p>
              {/* <p className="t-secondary-16 lh-24">
            Arup made its name in the twentieth century as the designer and
            engineer behind some of the world’s most ambitious structures. That
            creative strength and independence of mind continues to guide us.
            Today, Arup employs more than 13,000 people, in more than 35
            countries – in a culture underpinned by Sir Ove Arup’s aims and
            values.
          </p> */}
            </Grid>
            <Grid
              spacing={0}
              container
              alignItems={'center'}
              justify={'center'}
              spacing={0}
              className="template-about-middle-block"
            />
            <Grid container justify="center">
              <Grid item md={9} xs={6} className="about-block about-text-block">
                <div className="">
                  <p className="t-primary-24 t-weight-b c-blue-dark u-mrg-bot-100">
                    Why Luminaire Broker
                  </p>
                  <p className="t-secondary-16 lh-24">
                    By joining the Luminaire Broker platform as a registered
                    supplier, you gain immediate access to a network of over
                    1,000 Lighting Designers and Electrical Engineers working on
                    hundreds of live projects across the globe at any one time.
                    Products can be matched to specific project requirements and
                    the platform facilitates the development of robust lighting
                    specifications for those projects.
                  </p>
                </div>
              </Grid>
              <Grid
                item
                md={3}
                xs={6}
                className="about-block about-image-block"
              >
                <img src={img1} alt="" />
              </Grid>
            </Grid>
            {/* <Grid container justify="center">
          <Grid item md={3} xs={6} className="about-block about-text-block">
            <div className="">
              <p className="t-primary-24 t-weight-b c-blue-dark u-mrg-bot-140">
                Why Luminarie Broker
              </p>
              <p className="t-secondary-16 lh-24">
                By joining the Luminaire Broker platform as a registered
                supplier, you gain immediate access to Arup’s network of over
                1,000 Lighting Designers and Electrical Engineers working on
                hundreds of live projects across the globe at any one time.
                Products can be matched to specific project requirements and the
                platform facilitates the development of robust lighting
                specifications for those projects.
              </p>
            </div>
          </Grid>
          <Grid item md={3} xs={6} className="about-block about-image-block">
            <img src={img2} alt="" />
          </Grid>
        </Grid> */}
            <Grid container justify="center">
              <Grid item md={12} sm={8} xs={9} className="u-mrg-bot-40">
                <h2 className="t-secondary-32 t-weight-b c-blue-dark u-mrg-top-60 u-mrg-bot-30">
                  Knowledge sharing platform
                </h2>
                <p className="t-secondary-16 lh-24">
                  <b>Luminaire Broker</b> connects Lighting Designers and
                  Electrical Engineers to a far wider range of suppliers and
                  lighting products than is possible through traditional means.
                  The platform uniquely allows suppliers to target their product
                  offerings to highly specific parameters, and to gain an
                  understanding of what features are commonly requested across a
                  wide range of live projects. It enables designers and
                  engineers to find the optimal products to meet their
                  requirements, and to gain a better appreciation of the range
                  of equipment and features on the market, widening the palette
                  of materials available to them.
                </p>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default About;
